<template>
    <button class="operations-download-button"
            @click="$emit('download', value)"
    >
        <i class="uil uil-download-alt"></i>
    </button>
</template>

<script>
export default {
    name: 'download-button',
    emits: [
        'download',
    ],
    props: {
        value: {
            required: false
        },
    },
}
</script>
